export default {
    ambassadorBtn_title: 'Geschenkkartenverlosung',
    ambassadorBtn_subtitle: "Reviews = Rewards",
    ambassadorPopup_title: 'AN EINER GESCHENKKARTEVERLOSUNG TEILNEHMEN',
    ambassadorPopup_votes: '20 AirVotes',
    giveawayPopup_login: 'Mit Google oder Facebook anmelden',
    ambassadorPopup_review: 'Hinterlassen Sie eine Bewertung auf einer der Seiten von {v1}',
    giveawayPopup_entered: 'Sie werden an der Verlosung teilnehmen',
    ambassadorPopup_BtnLogin: 'Mit Anmeldung beginnen',
    giveawayPopup_BtnReview: 'Bewertung hinterlassen',
    ambassadorPopup_cancel: 'Ich möchte daran nicht teilnehmen',
    ambassadorFinishTitle: 'Wir bedanken uns für Ihre ehrliche Bewertung!\n\nSie wurden zu unserer Geschenkkartenverlosung hinzugefügt.\n\nKommen Sie zurück und stimmen Sie erneut ab: Jede Bewertung erhöht Ihre Chancen!',
    ambassadorMonthlyDrawing: "Every AirVote enters you into a monthly $100 drawing",
    ambassadorReceive: "Ambassadors will receive extra goodies and recognition!",
    ambassadorHelpUsTogether: "Help us succeed together!",
    giveawayPopup_proceedReview: "Fortfahren, um die Bewertung abzugeben",
    Thank_for_vote: "Vielen Dank für Ihre Bewertung. Möchten Sie Ihre Bewertungen beobachten? Sich einloggen mit",
    thankVoteTitle1: "Ihr Feedback wurde gespeichert",
    thankVoteTitle2_1: "Vielen Dank für Ihre Stimme",
    thankVoteTitle2_2: "Melden Sie sich bei AirVote® an, damit Sie Ihre Stimmen überprüfen und ändern können",
    writeFeedBack: "Notiz hinzufügen",
    voteSuccessText_1: "Vielen Dank! Ihre Bewertung wurde gesendet.",
    voteSuccessText_2: "Möchten Sie Ihre Bewertung ändern? Klicken Sie auf ein anderes Emoticon.",
    voteSuccessText_3: "Haben Sie etwas zu sagen? Hier können Sie optionale Notiz hinterlassen",
    feedbackTitle: "Notiz hinzufügen",
    feedbackTitleSoSo: "Was wäre besser?",
    feedbackTitleSad: "Was ist falsch?",
    feedbackTextRating: 'Warum haben Sie diesem Lautsprecher diese Bewertung gegeben?',
    writeAReview: "Öffentliche Abstimmung",
    writeAReviewTitle: "Hier können Sie eine Bewertung für {v1} abgeben:",
    Logout: "Abmeldung",
    Sync_status: "Synchronisierungsstatus",
    Close: "Schließen",
    Submit: "Senden",
    Cancel: "Rückgängig machen",
    reviewSocial: "Über uns",
    reviewSocialOr: "Mehr über uns",
    anonComment: "Anonymen Kommentar hinzufügen",
    powered_by: "Powered by AirVote\nHolen Sie es für Ihr Unternehmen",
    feedbackTextOr: "oder",
    UploadNewPhoto: "Neues Foto hochladen",
    RemovePhoto: "Foto entfernen",
    WrongFormat: "Falsches Format. Bitte PNG oder JPG verwenden",
    PhotoOverweight: "Foto ist größer als {v1}Mb",
    max_attach_photos_count_error: "Nur bis zu {v1} Dateien erlaubt",
    yourNote: "Ihr Kommentar",
    addYourNote: "Füg ein Notiz hinzu ?",
    commentPopupEmail: "Ihre E-Mail-Adresse oder Telefonnummer",
    feedbackText: "Kontaktieren Sie mich ",
    feedbackTextServiceLog: "Service-Kontaktinformationen",
    OK: "OK",
    title_404: "Die Seite, die Sie erreichen wollen\\ist nicht verfügbar",
    btn_404: "Zurückgehen",
    welcomeAmbassador: "Welcome back, J Bar Ambassador!",
    ambassadorDescription: "Every AirVote enters you into a monthly $100 drawing (limit 1 per location per day)\n" +
        "Ambassadors will receive extra goodies and recognition!\n" +
        "\n" + "Help us succeed together!",
    Placement: "Standort",
    Update: "Aktualisieren",
    NewPlacementSaved: "Neue Standort erfolgreich gespeichert",
    PleaseEnterCorrectPlacement: "Bitte geben Sie die korrekte Standort ein",
    manageGPSAllowTitle: "Haben Sie etwas dagegen, Ihren Standort zu teilen?",
    manageGPSAllowText: "Wenn wir den genauen Ort eines Problems kennen, können wir es schneller beheben. Wir werden Ihren Standort nicht verfolgen oder an Dritte außerhalb unseres Serviceteams weitergeben",
    manageGPSAllowOKButton: "OK zum Teilen",
    manageGPSAllowCancelButton: 'Lieber nicht',
    level2_notp: "Kein Toilettenpapier",
    level2_full: "Überfüllt",
    level2_dirty: "Schmutzig",
    level2_smells: "Riecht",
    level2_broken: "Gebrochen",
    level2_otherl: "Anderes",
    level2_nopaper: "Kein Papier/Handtücher",
    level2_title: "Erbrachte Dienstleistungen",
    level2_maxCount: "Maximale Anzahl von Artikeln zur Auswahl: {v1}",
    vote_screen_public_review_popup_title: "Hinterlassen Sie uns eine öffentliche Bewertung",
    QR_smiley_disabled: "Dieser QR-Smiley® wurde deaktiviert.\nBitte richten Sie Ihr Feedback direkt an das Unternehmen.",
    QR_smiley_disabled_links: "Haben Sie Fragen zu AirVote®?\nSchauen Sie unter {v1} nach oder schicken Sie uns eine E-Mail an {v2}.",
    QR_smiley_disabled_footer: "Vielen Dank für Ihr Feedback!",
    sl_final_Title1: "Service log saved!",
    noServiceLogs: "Keine Dienstprotokolle",
    serviceLogInfoBtn: "Servicegeschichte",
    profilePosition: "Personal",
    need_audio_permission_error: "Bitte geben Sie uns Zugang zu Ihrem Mikrofon für Audioaufnahmen",
    snapPicturePopupTitle: "Bestätigen Sie Ihre Wahl mit dem Bild der Toilette",
    snapPictureButton: "Ein Foto machen",
    snapPicturePopupContinue: "Continue",
    subtitleDefault: "Knipsen Sie es und gewinnen Sie unser monatliches Gewinnspiel!",
    signIn_Pin: "Sign in with PIN",
}
